<app-account-downloads-page [partialView]="true" [mb30]="true" />
<app-account-dreambox-page [partialView]="true" />
<app-account-invoices-page [partialView]="true" />
